var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('apexchart',{attrs:{"type":"pie","width":"380","options":_vm.platformInteractionChartOptions,"series":_vm.genderSeries}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }